var _filter, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFellowships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.847059,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.242188 4.882812 C 24.292969 4.820312 25.332031 4.882812 26.367188 5.078125 C 32.878906 8.203125 39.386719 11.328125 45.898438 14.453125 C 46.613281 14.910156 47.199219 15.496094 47.65625 16.210938 C 47.917969 21.289062 47.917969 26.367188 47.65625 31.445312 C 47.003906 31.964844 46.355469 31.964844 45.703125 31.445312 C 45.574219 28.449219 45.441406 25.457031 45.3125 22.460938 C 44.28125 23.136719 43.175781 23.660156 41.992188 24.023438 C 41.667969 28.574219 41.472656 33.132812 41.40625 37.695312 C 40.882812 40.039062 39.515625 41.667969 37.304688 42.578125 C 28.972656 45.441406 20.636719 45.441406 12.304688 42.578125 C 10.546875 41.863281 9.308594 40.625 8.59375 38.867188 C 8.160156 33.941406 7.835938 28.992188 7.617188 24.023438 C 5.582031 23.429688 3.824219 22.386719 2.34375 20.898438 C 1.207031 18.367188 1.660156 16.21875 3.710938 14.453125 C 10.304688 11.351562 16.816406 8.160156 23.242188 4.882812 Z M 24.023438 7.617188 C 31.199219 10.390625 38.167969 13.648438 44.921875 17.382812 C 45.183594 18.035156 45.183594 18.683594 44.921875 19.335938 C 38.339844 22.855469 31.632812 26.109375 24.804688 29.101562 C 18.117188 26.023438 11.476562 22.835938 4.882812 19.53125 C 4.304688 18.519531 4.433594 17.605469 5.273438 16.796875 C 11.605469 13.824219 17.855469 10.765625 24.023438 7.617188 Z M 10.742188 25.585938 C 15.335938 27.882812 20.023438 29.964844 24.804688 31.835938 C 29.539062 30.023438 34.164062 27.9375 38.671875 25.585938 C 39.035156 29.78125 38.90625 33.949219 38.28125 38.085938 C 37.695312 38.671875 37.109375 39.257812 36.523438 39.84375 C 28.710938 42.707031 20.898438 42.707031 13.085938 39.84375 C 12.140625 39.195312 11.425781 38.347656 10.9375 37.304688 C 10.742188 33.402344 10.675781 29.496094 10.742188 25.585938 Z M 10.742188 25.585938 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowships);
export default __webpack_public_path__ + "static/media/fellowships.4dad072b35cf0d665bd67c218d919fff.svg";
export { ForwardRef as ReactComponent };